export default __webpack_public_path__ + "media/images/business/no-image-625164e60afef1fd3bc74c74ea4e685f.png";